import {useContext} from 'react'
import {UiThemeContext} from './UiThemeContext'

export const useUiTheme = () => {
    const context = useContext(UiThemeContext)
    if (!context) {
        throw new Error('useUiTheme must be used within UiThemeProvider')
    }
    return context
}
